export default "__VITE_ASSET__DmvAWV7w__"